module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9rgoN"))).then(() => parcelRequire('3a9aZ'));